import { combineReducers } from 'redux';
import { tasksReducer } from './tasks';
import { materialReducer } from './materials';
import { labourReducer } from './labours';
import { defectReducer } from './defects';
import { taskHistoryReducer } from './taskHistory';
import { productHistoryReducer } from './productHistory';
import { warehouseProductReducer } from './warehouseProduct';
import { alertReducer } from './alert';
import { testReducer } from './test';
import filterReducer from '../slices/filterSlice';
import statusSlicer from '../slices/statusSlicer';
import generalSlice from '../slices/generalSlice';
import partnerReportSlice from '../slices/partnerReportSlice';
import paymentSlice from '../slices/paymentSlice';
import cuteStarSlice from '../slices/cuteStarSlice';

const rootReducer = combineReducers({
  tasks1: tasksReducer,
  materialReducer,
  labourReducer,
  defectReducer,
  taskHistoryReducer,
  productHistoryReducer,
  warehouseProductReducer,
  alertReducer,
  testReducer,
  filter: filterReducer,
  status: statusSlicer,
  general: generalSlice,
  partnerReport: partnerReportSlice,
  payment: paymentSlice,
  cuteStar: cuteStarSlice
});

export default rootReducer;
